import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import fontAwesome from "./fontAwesome"; // Import the fontAwesome configuration

createApp(App).use(store).use(fontAwesome).use(router).mount("#app");
